import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as globals from '@reusable/services/globals';
import { ToastrService } from 'ngx-toastr';
// import { ToastrService } from 'ngx-toastr/lib';
import { Parser } from 'xml2js';
import { map } from 'rxjs/operators';
@Injectable()
export class S3Uploader {
  private toastMessage = '';
  private toastType = 'info';
  constructor(private toastr: ToastrService, private httpClient: HttpClient) {}

  getS3Object(file, directory?) {
    const formData: FormData = new FormData();
    let files = [];
    if (file?.target) {
      files = file.target.files;
    } else if (file?.name) {
      files.push(file);
    }
    if (!files[0]) {
      throw new Error('لم تقم بإختيار ملف');
    }
    let params = {};
    if (directory) {
      params = {
        filename: files[0].name,
        content_type: files[0].type,
        directory
      };
    } else {
      params = {
        filename: files[0].name,
        content_type: files[0].type
      };
    }
    return this.httpClient
      .get(`${globals.domain}/upload`, {
        params,
        headers: globals.appendCfAccessHeaders(new HttpHeaders())
      })
      .pipe(map(
        res => {
          const responseData: any = res;
          if (responseData.params) {
            formData.append('key', responseData.params.key);
            formData.append('acl', responseData.params.acl);
            formData.append('success_action_status', responseData.params.success_action_status);
            formData.append('Policy', responseData.params.policy);
            formData.append('X-Amz-Algorithm', responseData.params['x-amz-algorithm']);
            formData.append('X-Amz-Credential', responseData.params['x-amz-credential']);
            formData.append('X-Amz-Date', responseData.params['x-amz-date']);
            formData.append('X-Amz-Signature', responseData.params['x-amz-signature']);
            // formData.append('Cache-Control', responseData.params['cache-control']);
            formData.append('file', files[0]);
            this.toastMessage = 'من فضلك انتظر ... جاري رفع الصورة...';
            this.toastType = 'success';
            this.toastr[this.toastType](this.toastMessage);
            return { formData, responseData };
          }
        },
        () => false
      ));
  }

  postS3Object(s3Object) {
    const fileResponse = {
      key: '',
      success: false,
      location: '',
      progress: 0
    };

    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Accept', 'application/xml, text/xml');

    const parser = new Parser();
    return this.httpClient
      .post(s3Object.responseData.endpoint_url, s3Object.formData, {
        headers,
        responseType: 'text',
        reportProgress: true,
        observe: 'events'
      })
      .pipe(map(
        resp => {
          const result: any = resp;
          this.toastr.clear();
          if (result?.loaded) {
            const progress = Math.round((result.loaded / result.total) * 100);
            fileResponse.progress = progress;
          }
          if (result.ok && result.type === 4) {
            parser.parseString(result.body, (err, xml) => {
              fileResponse.key = xml.PostResponse.Key[0].replace('customers/', '');
              fileResponse.location = xml.PostResponse.Location;
              fileResponse.success = true;
            });
          }
          return fileResponse;
        },
        () => (fileResponse.success = false)
      ));
  }
}